<template>
    <InputText :id="name" :class="{ 'p-invalid': errorMessage }"
               :name="name" :placeholder="placeholder" :type="type"
               :value="value"
               aria-describedby="text-error"
               @update:modelValue="$emit('update:modelValue', $event)"/>
    <small id="text-error" class="p-error">{{ errorMessage || '&nbsp;' }}</small>
</template>

<script lang="ts" setup>
import InputText from 'primevue/inputtext';
import {toRef} from "vue";

const props = defineProps<{
    type: string,
    placeholder: string,
    name: string,
    errorMessage: any,
    value: string
}>()

const name = toRef(props, 'name');

</script>
